export enum UserRole {
  SuperAdmin = 1,
  Admin = 2,
  Doctor = 3,
  Patient = 4,
}
